import { Injectable, Inject } from '@angular/core';
import { AlertService } from './alert.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlingService {

  constructor(private alertSvc: AlertService,
            @Inject('environment') private environment) {

  }

  public processHttpError(e: any): string {

    
    let errorMessage = e.message;

    if (e.error && e.error.code && e.error.message) {
      errorMessage="";

      if (e.error.code==500){
        errorMessage= "Server reported error: "
      }
      errorMessage = errorMessage + e.error.message;
    }

    this.alertSvc.error(this.environment.TOASTR_HEADER, errorMessage, 10000, true);

    return errorMessage;
  }

}
